module.exports = __webpack_public_path__ + "img/service-after-content-service@3x.ba9f175f.png";